<template>
  <span>
    <div v-if="status !== 'add' && dialogImageUrl" class="updateShowImg">
      <el-image
        style="width: 150px; height: 150px;"
        :src="dialogImageUrl"
        fit="contain"
      >
        <div slot="placeholder" class="sample-image-slot">
          加载中
        </div>
      </el-image>
      <span>
        <i class="el-icon-zoom-in" @click="updateHandlePictureCardPreview"></i>
        <i class="el-icon-delete" v-if="!disabled" @click="updateHandleRemove"></i>
      </span>
    </div>
    <el-upload
      v-else
      v-loading="uploadImgLoading"
      ref="upload"
      class="avatar-uploader"
      :action="action"
      list-type="picture-card"
      :http-request="UploadImage"
      :before-upload="onBeforeUploadImage"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-error="uploadError"
      :disabled="disabled"
    >
      <div class="upload-test">{{tipsText}}</div>
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog> -->
    <el-image-viewer
        v-if="dialogVisible"
        :on-close="()=> {dialogVisible = false}"
        :url-list="[dialogImageUrl]"
      />
  </span>
</template>
<script>
import upload from '@/utils/upload';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    // 框内提示信息
    tipsText: String
  },
  data: () => ({
    action: '',
    maxSize: 100,
    uploadImgLoading: false,
    dialogImageUrl: '',
    dialogVisible: false,
  }),
  watch: {
    imgUrl: {
      handler(val) {
        this.dialogImageUrl = val ? val + this.$ImgPreviewQuality : '';
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    // 检验图片
    onBeforeUploadImage(file) {
      document.querySelector('.el-upload').style.display = 'none';
      const fileType = file.name.split('.').pop();
      if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].indexOf(fileType) === -1) {
        this.$message.error('图片只能是 JPG/JPEG/PNG 格式!');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
        return false;
      }
      this.uploadImgLoading = true;
    },
    // 上传图片
    async UploadImage(param) {
      const { success, src, err } = await upload(
        process.env.VUE_APP_CML_BASE_URL + 'file/image/upload',
        param.file,
      );
      this.uploadImgLoading = false;
      if (success !== '1') {
        this.$message.error(err.msg);
        this.dialogImageUrl = '';
        return;
      }
      this.dialogImageUrl = success === '1' ? src : '';
      this.$emit('img-change', this.dialogImageUrl);
    },
    uploadError() {
      document.querySelector('.el-upload').style.display = 'inline-block';
      this.$message.error('图片上传失败，请重新上传！')
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    updateHandlePictureCardPreview() {
      this.dialogVisible = true;
    },
    updateHandleRemove() {
      this.dialogImageUrl = '';
      this.$emit('img-change', '');
      this.$emit('img-remove');
    },
    // 移除图片
    handleRemove() {
      this.dialogImageUrl = '';
      this.uploadImgLoading = false;
      this.$emit('img-change', '');
      document.querySelector('.el-upload').style.display = 'inline-block';
    },
  },
};
</script>
<style lang="less">
.el-upload {
  position: relative;
}
</style>
<style lang="less" scoped>
.avatar-uploader {
  display: inline-block;
}
.avatar {
  width: 100%;
}
.updateShowImg {
  float: left;
  width: 145px;
  height: 145px;
  position: relative;
  span {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, 0.5);
    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    .el-icon-delete {
      margin-left: 20px;
    }
  }
  &:hover {
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
/deep/ .el-upload-list__item-thumbnail {
  object-fit: contain;
}
.el-upload {
  .upload-test {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    line-height: 25px;
    width: 100%;
    color: #AB0033;
  }
}
</style>
